import React from 'react';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Visible label for screen-readers */
  srLabel?: string;
  /** Whether the button is visually active (adds ring) */
  active?: boolean;
}

/**
 * IconButton
 * Small, accessible icon button used across the app.
 * - Ensures 44x44px hit area
 * - Supports `sr-only` label for screen readers
 * - Applies `aria-pressed` when provided via props
 */
export function IconButton({ srLabel, active, className = '', children, ...rest }: IconButtonProps): React.ReactElement {
  return (
    <button
      {...rest}
      className={`inline-flex items-center justify-center rounded-md p-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 ${active ? 'bg-blue-50 text-blue-600 ring-2 ring-blue-300' : 'text-gray-600 hover:bg-gray-100'} ${className}`}
      style={{ width: 44, height: 44 }}
    >
      <span className="sr-only">{srLabel}</span>
      {children}
    </button>
  );
}

export default IconButton;
